import React from 'react';

const FormLoadingSpinner = ({
  message = 'Cargando formulario…',
  hint = 'Preparando almacenes, productos y datos de la guía',
  compact = false,
}) => (
  <div className={`flex flex-col items-center justify-center ${compact ? 'py-16' : 'py-24'} px-6`}>
    <div
      className="w-11 h-11 border-4 border-teal-200 border-t-teal-600 rounded-full animate-spin"
      aria-hidden="true"
    />
    <p className="mt-4 text-sm font-medium text-gray-700">{message}</p>
    {hint ? <p className="mt-1 text-xs text-gray-500 text-center max-w-sm">{hint}</p> : null}
  </div>
);

export default FormLoadingSpinner;
